import { SavedAssetSecuritiesChoice } from '../../custom-pdf-report-modal/enums/custom-pdf-report-saved-asset-securities-choice.enum';
export const DEFAULT_SAVED_ASSET_OPTIONS_CHOICES = {
    fund_chart_securities_choice: SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY,
    scatter_plot_securities_choice: SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY,
    comp_table_securities_choice: SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY,
    timeseries_table_securities_choice: SavedAssetSecuritiesChoice.SAVED_ASSET_SECURITIES_ONLY,
};
